<template>
    <div class="page">
        <div class="question">

            <van-list
                    v-model="loading"
                    :finished="finished"
                    :immediate-check="false"
                    offset="30"
                    finished-text="暂无更多记录"
                    @load="getMyQuestionTest"
                    v-if="list.length > 0"
            >

            <div class="question-li" v-for="(item,index) in list" :key="index" @click="bindGoToDetail(item.question_stat_user_id)">
                <div class="question-title">
                    <div class="question-name">
                        {{item.sections_name}}
                    </div>
                    <span class="question-state yes"></span>
                </div>
                <div class="question-col">
                    <div class="question-course-name">{{item.course_name}}</div>
                    <div class="question-course-time">{{item.modify_date}}</div>
                </div>
            </div>

            </van-list>

            <van-empty description="暂无更多记录" v-if="list.length == 0"/>
        </div>
    </div>
</template>

<script>
    import {List,Empty} from 'vant';
    export default {
        name: "index",
        components:{
            [List.name]:List,
            [Empty.name]:Empty
        },
        data(){
            return {
                finished:false,
                loading:false,
                list:[],
                total:0,
                page:1,
                pageSize:10
            }
        },
        mounted() {
            this.util.hideOptionMenu();
            this.getMyQuestionTest(1);
        },
        methods:{
            bindGoToDetail(id){
                this.$router.push(this.util.urlPrefix+'/question/detail?question_stat_user_id='+id+'&token='+this.util.token)
            },
            getMyQuestionTest(page){
                var _self=this;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page = pageNo;

                }else{

                    this.page = page;

                }

                this.util.server.mini_question.my_question_test({
                    data:{
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        this.loading=false;
                        const { code, data, msg } = res;
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.total = data.total
                            }
                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.list = data.items
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.list = this.list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.finished=false;

                                if(this.total*1 == this.list.length){
                                    this.finished=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.list=[];
                                    this.finished=true;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
        }
    }
</script>

<style scoped>
    .div{
        color: #3a3a3a;
    }
    .page{
        height: 100%;
        width: 100%;
    }
    .question-li{
        box-shadow: 1px 0 10px #eee;
        background-color: #fff;
        border: 1px solid #eee;
        padding: 15px 10px;
        margin: 10px;
    }
    .question-title,.question-col{
        display: flex;
    }
    .question-title{
        margin-bottom: 10px;
    }
    .question-title .question-state.yes{
        color: #44b549;
    }
    .question-title .question-state.no{
        color: #c9302c;
    }
    .question-name{
        flex: 1;
        /*margin-right: 20px;*/
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .question-course-name{
        flex: 1;
        font-size: 12px;
        color: #999;
    }
    .question-course-time{
        font-size: 12px;
        color: #999;
    }
</style>
